import React from "react"
import { createStyles, Flex, forwardRef } from "@design-system/core"
import { BadgeIconProps } from "./types"
import { BasicBadge } from "./BasicBadge"

export const IconBadge = forwardRef<BadgeIconProps, "div">((props, ref) => {
  const { icon, children, ...otherProps } = props

  const iconElement = React.cloneElement(React.Children.only(icon), {
    style: [styles.iconSVG, icon.props?.style],
  })

  return (
    <BasicBadge {...otherProps} variant="icon">
      <Flex>
        {iconElement}
        {children}
      </Flex>
    </BasicBadge>
  )
})

const styles = createStyles((theme) => ({
  iconSVG: {
    height: theme.spaces.spacing16,
  },
}))
